import VueRouter from 'vue-router';
window.Vue = require('vue');
Vue.use(VueRouter);

const routes = [
  { path: '/',name: 'home', component: () => import('./Pages/HomePage')},
  { path: '/notebook',name: 'notebook', component:  () => import('./Pages/NotebookPage')},
  { path: '/media',name: 'media', component:  () => import('./Pages/MediaPage')},
  { path: '/todo',name: 'todo', component:  () => import('./Pages/TodoPage')},
  { path: '/house/order',name: 'order', component:  () => import('./Pages/House/OrderPage')},
  { path: '/house/section',name: 'section', component:  () => import('./Pages/House/SectionPage')},
  { path: '/auth/Login',name: 'login', component:  () => import('./Pages/Auth/LoginPage')},
  // { path: '/auth/Signup',name: 'signup', component:  () => import('./Pages/Auth/SignupPage')},
  { path: '/auth/Logout',name: 'logout', component:  () => import('./Pages/Auth/LogoutPage')},
  { path: '/auth/profile',name: 'profile', component:  () => import('./Pages/Auth/ProfilePage')},
  { path: '/auth/role',name: 'role', component:  () => import('./Pages/Auth/RolePage')},
  { path: '/auth/user',name: 'user', component:  () => import('./Pages/Auth/UserPage')},
  { path: '/Finance/loan',name: 'FinLoan', component:  () => import('./Pages/Finance/LoanPage')},
  { path: '/Project/Home',name: 'project', component:  () => import('./Pages/Project/HomePage')},
  { path: '/Anakatey/Products',name: 'AnakateyProducts', component:  () => import('./Pages/Anakatey/ProductPage')},
  { path: '/Contacts/Person',name: 'contactPerson', component:  () => import('./Pages/Contacts/PersonPage')},
  { path: '/herrmann',name: 'herrmann', component:  () => import('./Pages/HerrmannPage')},
  { path: '/website',name: 'WebSite', component:  () => import('./Pages/WebSitePage')},
  { path: '/socailmedia/Account',name: 'socailmediaAccount', component:  () => import('./Pages/SocailMedia/AccountPage')},
  { path: '/socailmedia/Post',name: 'socailmediaPost', component:  () => import('./Pages/SocailMedia/PostPage')},
  { path: '/socailmedia/Template',name: 'socailmediaTemplate', component:  () => import('./Pages/SocailMedia/TemplatePage')},
  { path: '/chat',name: 'chat', component:  () => import('./Pages/Chat/ChatPage')},
];

const router = new VueRouter({
  //mode: 'history',
  routes: routes
});

export default router;